function SectionsContent({ page, stepAnchors = false }) {
  return (
    <>
      <p className="info-page-intro">{page.intro}</p>
      {page.sections.map((section, index) => (
        <section
          className="info-page-section"
          key={section.heading}
          {...(stepAnchors ? { id: `stap-${index + 1}` } : {})}
        >
          <h2>{section.heading}</h2>
          {section.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>
      ))}
    </>
  );
}

function StepsContent({ page }) {
  return (
    <>
      <p className="info-page-intro">{page.intro}</p>
      <ol className="info-page-steps">
        {page.steps.map((step) => (
          <li key={step.title}>
            <h2>{step.title}</h2>
            <p>{step.body}</p>
          </li>
        ))}
      </ol>
    </>
  );
}

function FaqContent({ page }) {
  return (
    <>
      <p className="info-page-intro">{page.intro}</p>
      <div className="info-page-faq">
        {page.items.map((item) => (
          <details className="info-page-faq-item" key={item.question}>
            <summary>{item.question}</summary>
            <p>{item.answer}</p>
          </details>
        ))}
      </div>
    </>
  );
}

const CONTENT_BY_PAGE = {
  about: SectionsContent,
  how: StepsContent,
  faq: FaqContent,
  privacy: SectionsContent,
  disclaimer: SectionsContent,
  importExport: SectionsContent,
};

export function InfoPageContent({ pageId, page, stepAnchors = false }) {
  const Content = CONTENT_BY_PAGE[pageId];
  if (!Content) return null;
  return <Content page={page} stepAnchors={stepAnchors} />;
}
